import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import M from 'materialize-css/dist/js/materialize'

export class Navbar extends Component {

  state = {
    goToBlog: null,
    goToProjects: null,
    goToPortfolio: null
  }

  componentDidMount () {
    document.addEventListener('DOMContentLoaded', () => {
      var elems = document.querySelectorAll('.sidenav')
      var instances = M.Sidenav.init(elems)
      return instances
    })
    
  }

  parsePageTitle = (url) => {

    if (url === '/') { return 'Portfolio' }
    else if (url.startsWith('/blog/') || url === '/blog') {
      return 'Blog'
    }
    else {
      return url.slice(1).charAt(0).toUpperCase() + url.slice(2)
    }
  }

  render() {
    return (
      <div className="nav-container more-top-margin more-left-margin sticky">
        <nav>
          <div className="nav-wrapper">
            <a href="#!" className="brand-logo center"> </a>
            <ul id="nav-mobile" className="left hide-on-med-and-down">

              <li><NavLink exact activeClassName="nav-link--active" className="nav-link more-left-margin small-text no-background portfolio-link" to={
                this.props.location.pathname !== '/' ? '/' : this.props.location.pathname
              }>Portfolio</NavLink></li>

              <li><a className="nav-link small-text no-background" target="_blank" rel="noopener noreferrer" href="https://github.com/skadewdle">Github</a></li>

              <li><NavLink exact activeClassName="nav-link--active" className="nav-link more-left-margin small-text no-background projects-link" to='/projects'>Projects</NavLink></li>

              <li><NavLink exact activeClassName="nav-link--active" onClick={this.state.goToBlog} className={
                this.props.location.pathname.startsWith('/blog/') ? 'nav-link more-left-margin small-text no-background nav-link--active blog-link' : 'nav-link more-left-margin small-text no-background blog-link'
              } to="/blog">Blog</NavLink></li>

            </ul>
          </div>
        </nav>
        <ul id="slide-out" className="sidenav navbar-hidden">
          <li><a onClick={e => {
            e.preventDefault()
            setTimeout(() => {
            document.querySelector("#slide-out").classList.remove('navbar-shown')
            }, 100)

          }} className="sidenav-close" href="#!"><img style={{ height: '1.5rem' }} src="/images/close.svg" alt="Close icon to close the navbar"/></a></li>

          <li><Link onClick={(e) => {
            document.querySelector('.portfolio-link').click()
            setTimeout(() => document.querySelector("#slide-out > li:nth-child(1) > a").click(), 500)
          }} className="sidenav-link more-left-margin small-text no-background" to="/">Portfolio</Link></li>

          <li><Link onClick={() => {
            document.querySelector("#nav-mobile > li:nth-child(2) > a").click()
            setTimeout(() => document.querySelector("#slide-out > li:nth-child(1) > a").click(), 500)
          }} className="sidenav-link more-left-margin small-text no-background" to="/">Github</Link></li>


          <li><Link onClick={(e) => {
            document.querySelector('.projects-link').click()
            setTimeout(() => document.querySelector("#slide-out > li:nth-child(1) > a").click(), 500)
          }}className="sidenav-link more-left-margin small-text no-background" to="/projects">Projects</Link></li>

          <li><Link onClick={(e) => {
            document.querySelector('.blog-link').click()
            setTimeout(() => document.querySelector("#slide-out > li:nth-child(1) > a").click(), 500)
          }} className="sidenav-link more-left-margin small-text no-background" to="/blog">Blog</Link></li>

        </ul>
        <a href="/" onClick={(e) => {
          window.scrollTo(0, 0)
          document.querySelector("#slide-out").classList.add('navbar-shown')
          e.preventDefault()
        }
        } data-target="slide-out" className="sidenav-trigger"><img src="/images/menu.svg" style={{ width: '2.2rem'}} alt="Menu icon that opens the Navbar"/></a>

        <div className="mobile-page-text">
          <p data-text="blog title" className="page-title blog-title-hidden blog-navbar-title animated fadeIn"></p>
          <p className="page-title animated fadeIn page-title-main">{
            this.parsePageTitle(this.props.location.pathname)
          }</p>
        </div>
      </div>
    )
  }
}


export default Navbar